import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .InvestDetailPage__chart-tabs {
    margin: rem(20px 0);
  }

  .InvestDetailPage__investments-tabs {
    margin-bottom: rem(20px);
  }

  .InvestDetailPage__tab {
    font-size: rem(20px);
    line-height: 23px;
    margin-right: ${isRTL ? '0' : '35px'};
    margin-left: ${isRTL ? '35px' : '0'};
    padding-bottom: 15px;
    cursor: pointer;
    border-bottom: 3px solid transparent;

    &:last-child {
      margin-right: 0;
    }

    @include respond-to(sm) {
      font-size: 15px;
      line-height: normal;
      padding-bottom: 5px;
      border-bottom-width: 2px;
      margin-right: ${isRTL ? '0' : '15px'};
      margin-left: ${isRTL ? '15px' : '0'};
    }
  }

  .InvestDetailPage__invest-caption {
    margin: rem(30px 0);
    font-size: rem(20px);
  }

  .InvestDetailPage__back-to {
    font-size: 13px;
    line-height: 18px;
    color: #777777;
    margin: -14px 0 0 0;
    padding: 10px 0 10px 14px;
    position: relative;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &:before {
      content: '';
      width: 10px;
      height: 1px;
      background: #777777;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%)
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .InvestDetailPage__tab {
      &.active {
        color: ${colors.primary.hex};
        border-bottom-color: ${colors.primary.hex};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
